import { NavigationItem } from '@globalmed/atlas-ui';

export interface INavigationItemPlus extends NavigationItem {
  route: string;
  subItems?: INavigationItemPlus[];
}

export enum EExternalLinks {
  PRIVACY_POLICY = 'https://www.globalmed.com/legal/privacy-statement/',
}

export enum ERouterNames {
  ACCOUNT_SETTINGS = '/account-settings',
  ACCOUNT_SETTINGS__CALENDAR = 'calendar',
  ACCOUNT_SETTINGS__EPRESCRIBE = 'e-prescribe',
  ACCOUNT_SETTINGS__MY_ACCOUNT = 'my-account',
  ACCOUNT_SETTINGS__NOTIFICATIONS = 'notifications',
  BASE = '/',
  DASHBOARD = '/dashboard',
  DASHBOARD__SCHEDULE_APPOINTMENT = 'schedule-appointment',
  DASHBOARD__SEE_PROVIDER_NOW = 'see-provider-now',
  DASHBOARD__APPOINTMENT_CONFIRMATION = 'appointment-confirmation/:appointmentId',
  DASHBOARD__ISABEL = 'isabel',

  APPOINTMENT__JOIN = '/appointments/:appointmentId/join',
  MEDICAL_STAFF_CHAT = 'chats/medical-staff/:chatId',
  CHAT = 'chats/:chatId',
  ENCOUNTER = 'encounters/:encounterId',
  MEDICAL_STAFF_ENCOUNTER = 'encounters/medical-staff/:encounterId/:chatId',
  WAITING_ROOM = 'waiting-rooms/:waitingRoomId',
  SESSION_ENDED = 'session-ended',
  LEFT = 'left',

  FIRST_LOGIN = '/first-login',
  FIRST_LOGIN__PARTICIPANT_FORM = 'participant-form',
  FORGOT_PASSWORD = '/forgot-password',
  INSTITUTION_SETTINGS = '/institution-settings',
  INVITE_BY_TOKEN = '/invite/:token',
  INVITE_LINK = '/invite-link',
  LOGIN = '/login',
  LOGIN_DEVICE = '/login/device',
  PAGE_NOT_FOUND = '/page-not-found',
  PASSWORD_RESET_CONFIRMATION = '/password-reset-confirmation',
  PAYMENT_CALLBACK = '/payments/:paymentId/:result',
  PAYMENTS_INITIALIZE = '/payments/:paymentId',
  PROVIDERS = '/providers',
  PROVIDER = '/providers/:providerId',
  RESET_PASSWORD = '/reset-password/:code',
  ROUTE_ME = '/route-me',
  SENTRY_CHECK = '/sentry-error-check',
  SESSIONS = '/past-sessions',
  SIGNUP = '/signup/:code',
  USERS_TABLE = '/users-table',
  VERIFY_EMAIL = '/verify-email',
  VITALTRAC = '/vitals-scan',
  MY_DATA = '/my-data',
  GUEST = '/guest',
  DATA_REPORTING = '/data-reporting',
  DATA_REPORTING__REPORT = ':reportId',

  PATIENTS = '/patients',
  PATIENT = '/patients/:patientId',

  PATIENT_DOSESPOT = '/patients/:patientId/dosespot',

  DOCUMENT_MANAGEMENT = '/document-management',
  FORM_BUILDER_PREVIEW = 'form-builder/:formBuilderId/preview',
  FORM_BUILDER = 'form-builder/:formBuilderId',

  FORM_BUILDER_ENTRY_EDIT = '/entries/:formBuilderEntryId/edit',
  FORM_BUILDER_ENTRY_VIEW = '/entries/:formBuilderEntryId/view',
  GUEST_FORM_BUILDER_ENTRY_VIEW = 'entries/:formBuilderEntryId/view',

  VISIT_NOTES_TEMPLATES = '/visit-notes/templates',
  VISIT_NOTE_TEMPLATE_EDIT = '/visit-notes/templates/:formBuilderId/edit',
  VISIT_NOTE_TEMPLATE_PREVIEW = '/visit-notes/templates/:formBuilderId/preview',

  COMMAND_CENTER = '/command-center',
  SCHEDULE_AND_OUTREACH = '/schedule-and-outreach',
}

export enum EKioskRouterNames {
  KIOSK = '/kiosk',
  KIOSK__UNAVAILABLE = 'unavailable',
  KIOSK__LOGOUT_NOTICE = 'logout-notice',
  KIOSK__UNAVAILABLE_NOTICE = 'unavailable-notice',
  // KIOSK_NOT_AUTH
  KIOSK__CONTINUE = 'continue',
  KIOSK__LOGIN_USER = 'login',
  KIOSK__FORGOT_PASSWORD = 'forgot-password',
  KIOSK__SIGNUP_USER = 'signup/:code',
  KIOSK__RESET_PASSWORD = 'reset-password/:code',
  KIOSK__PASSWORD_RESET_CONFIRMATION = 'password-reset-confirmation',

  // END KIOSK_NOT_AUTH
  KIOSK_ACTIVATION = '/kiosk/activation',

  // onboarding
  KIOSK__FIRST_LOGIN = 'first-login',
  KIOSK__FIRST_LOGIN__PARTICIPANT_FORM = 'participant-form',

  KIOSK__DASHBOARD = 'dashboard',
  KIOSK__DASHBOARD__SCHEDULE_APPOINTMENT = 'schedule-appointment',
  KIOSK__DASHBOARD__SEE_PROVIDER_NOW = 'see-provider-now',
  KIOSK__DASHBOARD__APPOINTMENT_CONFIRMATION = 'appointment-confirmation/:appointmentId',

  KIOSK__FORM_BUILDER_ENTRY_EDIT = 'entries/:formBuilderEntryId/edit',
  KIOSK__FORM_BUILDER_ENTRY_VIEW = 'entries/:formBuilderEntryId/view',

  KIOSK__CHAT = 'chats/:chatId',
  KIOSK__ENCOUNTER = 'encounters/:encounterId',
  KIOSK__WAITING_ROOM = 'waiting-rooms/:waitingRoomId',
  KIOSK__SESSION_ENDED = 'session-ended',
  KIOSK__LEFT = 'left',
}
